import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CalendarGlyph = /*#__PURE__*/createElement("g", {
  id: "calendar"
}, /*#__PURE__*/createElement("path", {
  d: "M65,24.5v36.6H19V24.5H65 M66,21.5H18c-1.1,0-2,0.9-2,2v38.6c0,1.1,0.9,2,2,2h48c1.1,0,2-0.9,2-2V23.5 C68,22.4,67.1,21.5,66,21.5L66,21.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M43.5,15c0-0.6-0.5-1-1-1h-1c-0.5,0-1,0.4-1,1v11c0,0.5,0.5,1,1,1h1c0.5,0,1-0.5,1-1V15z"
}), /*#__PURE__*/createElement("path", {
  d: "M55,15c0-0.6-0.5-1-1-1h-1c-0.5,0-1,0.4-1,1v11c0,0.5,0.5,1,1,1h1c0.5,0,1-0.5,1-1V15z"
}), /*#__PURE__*/createElement("path", {
  d: "M32,15c0-0.6-0.5-1-1-1h-1c-0.5,0-1,0.4-1,1v11c0,0.5,0.5,1,1,1h1c0.5,0,1-0.5,1-1V15z"
}), /*#__PURE__*/createElement("polygon", {
  points: "33.5,41.5 27.6,41.5 27.5,35.5 33.4,35.5"
}), /*#__PURE__*/createElement("polygon", {
  points: "45,41.5 39.1,41.5 39,35.5 44.9,35.5"
}), /*#__PURE__*/createElement("polygon", {
  points: "56.5,41.5 50.6,41.5 50.5,35.5 56.4,35.5"
}), /*#__PURE__*/createElement("polygon", {
  points: "33.5,52.5 27.6,52.5 27.5,46.5 33.4,46.5"
}), /*#__PURE__*/createElement("polygon", {
  points: "45,52.5 39.1,52.5 39,46.5 44.9,46.5"
}), /*#__PURE__*/createElement("polygon", {
  points: "56.5,52.5 50.6,52.5 50.5,46.5 56.4,46.5"
}));
const Calendar = createSvg({
  name: 'calendar',
  path: CalendarGlyph
});

export default Calendar;
export { CalendarGlyph };
